import { FilterFrames } from '@mui/icons-material';
import { Alert, Grid } from '@mui/material';
import { Fragment } from 'react';

import { CopyText } from '../../../components/CopyText';
import { CustomAccordion } from '../../../components/CustomAccordion';
import { type Veranstaltung } from '../../../dtos';

type VeranstaltungsMiroProps = {
  readonly veranstaltung: Veranstaltung;
};

export const VeranstaltungsMiroComponent = ({ veranstaltung }: VeranstaltungsMiroProps) => (
  <CustomAccordion title="Miro Boards" icon={FilterFrames} open={veranstaltung.miroboards.length > 0}>
    {veranstaltung.miroboards.length > 0 ? (
      <Grid container spacing={1} rowSpacing={-5} alignItems="center">
        {veranstaltung.miroboards.map((board) => (
          <Fragment key={board.id}>
            <Grid size={5}>Miro-ID:</Grid>
            <Grid size={7}>
              <b>{board.miroid}</b>
            </Grid>
            <Grid size={5}>Miro-URL:</Grid>
            <Grid size={7}>
              <CopyText text={board.url} />
            </Grid>
            <Grid size={5}>Miro-Password:</Grid>
            <Grid size={7}>
              <CopyText text={board.password} />
            </Grid>
            <Grid size={5}>Referenten:</Grid>
            <Grid size={7}>
              {board.referenten.map((referent) => `${referent.vorname} ${referent.nachname}`).join(', ')}
            </Grid>
          </Fragment>
        ))}
      </Grid>
    ) : (
      <Alert severity="info">Kein Miro-Board vorhanden</Alert>
    )}
  </CustomAccordion>
);
